import axios from 'axios';

const LoanGroupService = {
  async getLoanGroup(groupId) {
    const response = await axios.get(`/loan_group/${groupId}`);

    return response.data;
  },

  async createLoanGroup(formValues) {
    const response = await axios.post('/loan_group', formValues);

    return response.data;
  },

  async updateLoanGroup({ loanGroupId, formValues }) {
    const response = await axios.patch(
      `/loan_group/${loanGroupId}`,
      formValues
    );

    return response.data;
  },

  async deleteLoanGroup(groupId) {
    const response = await axios.delete(`/loan_group/${groupId}`);

    return response.data;
  },

  async getLoanGroupTapes(groupId) {
    const response = await axios.post(`/loan_group/${groupId}/tape`);

    return response.data;
  },
};

export default LoanGroupService;
